export default __webpack_public_path__ + "static/media/asterix-bleu.5413c245.svg";